import { BottomNavigation, BottomNavigationAction, AppBar, SvgIcon, Badge } from '@material-ui/core';
import { ApplicationState } from '../store';
import { NotificationsNone, AccountCircle, PeopleOutlined, AssessmentOutlined, LocalHospital } from '@material-ui/icons';
import * as React from 'react';
import * as APIStore from "../store/APIStore";
import { connect, useSelector } from "react-redux";
import { DrawerBadge } from './DrawerBadge';

import { NavLink } from 'react-router-dom';
import './BottomNav.css';

const BottomNav = (props:any) => {
    const [value, setValue] = React.useState('patients');
    let {getUnreadMessageCount, NotificationCount} = props;
    const handleChange = (e: any) => {

        setValue(e.target.value);

    };

    return (
        <AppBar position="fixed" color="primary" style={{ top: "auto", bottom: 0 }}>
            <BottomNavigation value={value} onChange={handleChange} showLabels={true} >
                <BottomNavigationAction component={NavLink} label="Dashboard" to="/dashboard" icon={<AssessmentOutlined />} />
                <BottomNavigationAction component={NavLink} label="Patients" to="/patient-list-practice" icon={<PeopleOutlined />} />
                <BottomNavigationAction component={NavLink} label="Notifications" to="/notifications" icon={<DrawerBadge notificationState={NotificationCount} ></DrawerBadge>} />
                <BottomNavigationAction component={NavLink} label="Direct&nbsp;Admit" to="/direct-admit-request" icon={<LocalHospital />} />
                <BottomNavigationAction component={NavLink} label="Account" to="/account" icon={<AccountCircle />} />
            </BottomNavigation>
        </AppBar>
    );
}

export default connect(
    (state: ApplicationState) => state.vitalsContext,
    APIStore.actionCreators
)(BottomNav as any);


